import { render, staticRenderFns } from "./BasePanel1.vue?vue&type=template&id=20f8aa9f&scoped=true&"
import script from "./BasePanel1.vue?vue&type=script&lang=js&"
export * from "./BasePanel1.vue?vue&type=script&lang=js&"
import style0 from "./BasePanel1.vue?vue&type=style&index=0&id=20f8aa9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f8aa9f",
  null
  
)

export default component.exports